export default __webpack_public_path__ + "static/media/app_linebank.ffb13555.png";